<template>
  <div class="index_container applyMeet">
    <div class="applyMeet_info_title">申请测试会议</div>
    <div class="applyMeet_main">
      <div class="applyMeet_info_block">
        <div class="applyMeet_info_row">
          <div class="applyMeet_info_row_key"><span>*</span>测试会议日期:</div>
          <div class="applyMeet_info_row_value">
            <el-date-picker
              v-model="data.date"
              type="date"
              placeholder="请选择"
            />
          </div>
        </div>
        <div class="applyMeet_info_row">
          <div class="applyMeet_info_row_key"><span>*</span>开始时间:</div>
          <div class="applyMeet_info_row_value">
            <el-time-select
              v-model="data.time"
              placeholder="请选择"
              start="18:00"
              step="01:00"
              end="20:00"
            />
          </div>
        </div>
        <div class="applyMeet_info_row">
          <div class="applyMeet_info_row_key"><span>*</span>会议主席:</div>
          <div class="applyMeet_info_row_value margin_left">xxxx</div>
        </div>
        <div class="applyMeet_info_row">
          <div class="applyMeet_info_row_key"><span>*</span>会议讲者:</div>
          <div class="applyMeet_info_row_value margin_left">xxxx</div>
        </div>
        <div class="applyMeet_info_row">
          <div class="applyMeet_info_row_key"><span>*</span>讨论嘉宾1:</div>
          <div class="applyMeet_info_row_value margin_left">xxxx</div>
        </div>
      </div>

      <div class="applyMeet_info_block btn_group">
        <el-button class="submit" type="primary" @click="goToApply">
          <span>确认申请</span>
        </el-button>
        <div class="colorRed prompt">确认申请后，请等待后台审核确认</div>
      </div>
    </div>
  </div>
</template>
<script>
// import { Close } from "@element-plus/icons";

export default {
  name: "index",
  data() {
    return {
      search: "",
      data: {
        date: "",
        time: "",
      },
      config: {},
    };
  },
  computed: {},
  async created() {},
  mounted() {},
  methods: {
    //申请
    goToApply() {
      this.config.msg.isShow = true;
    },
  },
};
</script>
<style >
.index_container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.applyMeet_info_title {
  background: #e64638;
  color: #fff;
  padding: 0.75rem 0;
  text-align: center;
}
.applyMeet_main {
  flex: 1 0 0;
  overflow: auto;
  padding: 0 0.5rem;
}

.applyMeet_info_block_title {
  color: #e64638;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  margin: 6 0;
  padding: 0.5rem 0;
}

.applyMeet_info_row {
  min-height: 2.5rem;
  display: flex;
  border-bottom: 1px solid #ccc;
  align-items: center;
}
.applyMeet_info_row_key {
  height: 100%;
  width: 7.5rem;
  text-align: right;
  margin-right: 1rem;
}
.applyMeet_info_row_value {
  flex: 1 0 0;
}

.applyMeet .el-input__inner {
  border: none;
  font-size: 1rem;
}

.applyMeet .btn_group {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin: 1.5rem 0;
}
.applyMeet .btn_group .submit {
  width: 40%;
  background: #e64638;
  border: none;
}
.applyMeet .btn_group .prompt {
  border: none;
  margin-top: 1rem;
}

.applyMeet .margin_left {
  margin-left: 33px;
}
</style>